import React, { Component } from 'react';
import { 
  Container,
  Row,
  Col
} from 'reactstrap';

import Layout from '../components/layout';

import PageTwo from '../components/slides/page2';
import PageFour from '../components/slides/page4';
import PageFive from '../components/slides/page5';
import PageSeven from '../components/slides/page7';
import PageEight from '../components/slides/page8';
import PageNine from '../components/slides/page9';
import PageTen from '../components/slides/page10';
import PageEleven from '../components/slides/page11';
import PageTwelve from '../components/slides/page12';
import PageThirteen from '../components/slides/page13';
import PageFourteen from '../components/slides/page14';
import PageSixteen from '../components/slides/page16';

import { Helmet } from 'react-helmet';

class IndexPage extends Component {
  render() {
    return(
      <Layout>
        <Helmet defer={false}>
            <title>BraveCo - Vortex</title>
            <link rel="canonical" href="http://braveco.com.au/" />
        </Helmet>
        <main>
          <Container fluid>
            <Row >
              <Col xs='12' className="hero-image-contianer">
                <div className="hero-image image page-06b w-100"></div>
              </Col>
            </Row>
            <Row className="bg-darkgreen">
              <Col xs={{ size: 6}} md={{ size: 4, offset: 2,}}>
                <a href="#industry" className="text-white">Industry <br className="hidden-sm-up"/>&amp;  Mining</a>
              </Col>
              <Col xs='6' md='4' className="environment-container">
                <a href="#environment" className="text-white">Environment <br className="hidden-sm-up"/>&amp; Recycling</a>
              </Col>
            </Row>
          </Container>  
          <Container>
            <Row>
              <Col xs='12' className="pt-5 text-left">
                <h1 id="machine" className="text-darkgreen d-inline-flex justify-content-start red-underlinez flex-wrap">
                  <span className='text-black red-underline'>Brave</span>
                  <span className='text-purple red-underline'>Co&nbsp;</span>
                  <span className='red-underline'>presents&nbsp;</span>
                  <span className='red-underline'>the&nbsp;</span>
                  <span className='red-underline'>Universal&nbsp;</span>
                  <span className='red-underline'>Vortex&nbsp;</span>
                  <span className='red-underline'>Machine</span>
                </h1>
              </Col>
            </Row>
            <div className="slides pt-2">
              <PageTwo/>
              <PageFive/>
              <PageFour/>
              <div className="position-relative" id="industry" />
            </div>
            <Row>
              <Col xs='12' className="text-left">
                <h2 className="text-darkgreen d-inline-flex justify-content-start red-underline">Industry  &amp;  Mining applications</h2>
              </Col>
            </Row>
            <div className="slides pt-2">
              <PageEight/>
              <PageEleven/>
              <PageThirteen/>
              <PageFourteen/>
              <PageSixteen/>
              <div className="position-relative" id="environment" />
            </div>
            <Row>
              <Col xs='12' className="text-left">
                <h2 className="text-darkgreen d-inline-flex justify-content-start red-underline">Environment  &amp;  Recycling</h2>
              </Col>
            </Row>
            <div className="slides pt-2">
              <PageSeven/>
              <PageNine/>
              <PageTen/>
              <PageTwelve/>
            </div>
          </Container>
        </main>
      </Layout>
    );
  }
}

export default IndexPage;